module.exports = __webpack_public_path__ + "img/kenya-reco.321f9446.svg";